const YT_ID_RE = /^[A-Za-z0-9_-]{11}$/;

function asId(candidate: string | null | undefined): string | null {
  if (!candidate) return null;
  return YT_ID_RE.test(candidate) ? candidate : null;
}

/**
 * חילוץ מזהה סרטון מכתובות YouTube נפוצות:
 * watch?v= | youtu.be/ | shorts/ | embed/ | live/ | מזהה גולמי
 */
export function extractYouTubeId(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const s = raw.trim();
  if (!s) return null;
  if (YT_ID_RE.test(s)) return s;
  let u: URL;
  try {
    u = new URL(/^https?:\/\//i.test(s) ? s : `https://${s}`);
  } catch {
    return null;
  }
  const host = u.hostname.replace(/^(www\.|m\.)/, '').toLowerCase();
  if (host === 'youtu.be') {
    return asId(u.pathname.split('/').filter(Boolean)[0]);
  }
  if (host.endsWith('youtube.com') || host === 'youtube-nocookie.com') {
    const v = u.searchParams.get('v');
    if (asId(v)) return v;
    const m = /^\/(?:embed|shorts|live|v)\/([A-Za-z0-9_-]{11})(?:[/?]|$)/.exec(u.pathname);
    if (m) return m[1] ?? null;
  }
  return null;
}

/** כתובת הטמעה (ללא עוגיות) להצגה בתוך הטרמינל */
export function youTubeEmbedUrl(videoId: string): string {
  return `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1`;
}
